/**
 * @generated SignedSource<<0162d62948174db8e1d9368e7461cd4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CutOffList_component$data = {
  readonly cutOffTable: {
    readonly " $fragmentSpreads": FragmentRefs<"CutOffTable_table">;
  } | null | undefined;
  readonly disclaimer: string | null | undefined;
  readonly downloadOverview: {
    readonly " $fragmentSpreads": FragmentRefs<"CutOffListDownload_cutOffListDownload">;
  } | null | undefined;
  readonly introduction: string | null | undefined;
  readonly salesAdmission: {
    readonly " $fragmentSpreads": FragmentRefs<"LabeledSelectBox_labeledSelectBox">;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "CutOffList_component";
};
export type CutOffList_component$key = {
  readonly " $data"?: CutOffList_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"CutOffList_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CutOffList_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "introduction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disclaimer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CutOffTable",
      "kind": "LinkedField",
      "name": "cutOffTable",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CutOffTable_table"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LabeledSelectBox",
      "kind": "LinkedField",
      "name": "salesAdmission",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LabeledSelectBox_labeledSelectBox"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SimpleLink",
      "kind": "LinkedField",
      "name": "downloadOverview",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CutOffListDownload_cutOffListDownload"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CutOffList",
  "abstractKey": null
};

(node as any).hash = "098d02b3431a8ff0161a0c4c5f15dfb3";

export default node;
